<div class="detaljer">
  <entitetikon type="Beslutning" stoerrelse="20px"/>
  <span class="tittel" data-testid="beslutning-tittel">
    @if (harTittel()) {
      {{ tittel() }}
    } @else {
      <html-formatert [innhold]="beskrivelse()"/>
    }
  </span>
</div>
@if(harTittel() && harBeskrivelse()){
  <div class="beskrivelse" data-testid="beslutning-beskrivelse">
    <html-formatert [innhold]="beskrivelse()"/>
  </div>
}
